import { STEP } from './timer.actions'

export const getTimers = (state) => state.timers
export const getTimer = (state, timerId) => state.timers[timerId]
export const getRemainingSeconds = (state, timerId) => {
  const remainingTicks = (state.timers[timerId] || {}).remaining || 0
  return (remainingTicks * STEP) / 1000.0
}
